/* eslint-disable no-magic-numbers */
import {
  bioEntitiesForSelectedSearchElementSelector,
  bioEntitiesPerModelSelector,
  bioEntityIsContentTabOpenedSelector,
  loadingBioEntityStatusSelector,
} from '@/redux/bioEntity/bioEntity.selectors';
import { toggleIsContentTabOpened } from '@/redux/bioEntity/bioEntity.slice';
import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from '@/shared/Accordion';
import { searchModelElementsPerModelSelector } from '@/redux/modelElements/modelElements.selector';
import { highlightReactionsPerModelSelector } from '@/redux/reactions/reactions.selector';
import { ONE, ZERO } from '@/constants/common';
import { NewReaction } from '@/types/models';
import { BioEntitiesSubmapItem } from './BioEntitiesSubmapItem';

export const BioEntitiesAccordion = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const loadingBioEntityStatus = useAppSelector(loadingBioEntityStatusSelector);
  const searchModelElementsPerModel = useAppSelector(searchModelElementsPerModelSelector);
  const bioEntitiesForSelectedSearchElement = useAppSelector(
    bioEntitiesForSelectedSearchElementSelector,
  );
  const bioEntitiesPerModel = useAppSelector(bioEntitiesPerModelSelector);
  const isContentTabOpened = useAppSelector(bioEntityIsContentTabOpenedSelector);
  const reactionsPerModel = useAppSelector(highlightReactionsPerModelSelector);

  const models = [];
  for (let i = 0; i < searchModelElementsPerModel.length; i += ONE) {
    const model = searchModelElementsPerModel[i];
    const bioEntity = bioEntitiesPerModel.find(
      bioEntityPerModel => bioEntityPerModel.modelId === model.modelId,
    );
    let reactions: NewReaction[] = [];
    for (let j = 0; j < reactionsPerModel.length; j += ONE) {
      const reactionModel = reactionsPerModel[j];
      if (reactionModel.modelId === model.modelId) {
        reactions = reactionModel.highlightReactions;
      }
    }
    models.push({
      modelName: model.modelName,
      modelId: model.modelId,
      elements: model.modelElements,
      numberOfBioEntities: bioEntity?.numberOfEntities || 0,
      reactions,
    });
  }
  for (let j = 0; j < reactionsPerModel.length; j += ONE) {
    const reactionModel = reactionsPerModel[j];
    const bioEntity = bioEntitiesPerModel.find(
      bioEntityPerModel => bioEntityPerModel.modelId === reactionModel.modelId,
    );
    const found = models.filter(model => model.modelId === reactionModel.modelId).length > ZERO;
    if (!found) {
      models.push({
        modelName: reactionModel.modelName,
        modelId: reactionModel.modelId,
        elements: [],
        numberOfBioEntities: bioEntity?.numberOfEntities || 0,
        reactions: reactionModel.highlightReactions,
      });
    }
  }
  models.sort((a, b) => {
    let diff = b.numberOfBioEntities - a.numberOfBioEntities;
    if (diff === ZERO) {
      diff = a.modelName.localeCompare(b.modelName);
    }
    return diff;
  });

  const toggleTabOpened = (): void => {
    dispatch(toggleIsContentTabOpened(!isContentTabOpened));
  };

  return (
    <AccordionItem dangerouslySetExpanded={isContentTabOpened}>
      <AccordionItemHeading>
        <AccordionItemButton onClick={toggleTabOpened}>
          Content {loadingBioEntityStatus === 'pending' && ' (Loading...)'}
          {loadingBioEntityStatus === 'succeeded' &&
            ` (${bioEntitiesForSelectedSearchElement?.data?.length})`}
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        {models.map(model => (
          <BioEntitiesSubmapItem
            key={model.modelName}
            mapName={model.modelName}
            mapId={model.modelId}
            numberOfModelElements={model.numberOfBioEntities}
            modelElements={model.elements}
            reactions={model.reactions}
          />
        ))}
      </AccordionItemPanel>
    </AccordionItem>
  );
};
